const LOCALS = {
  home_page: 'home_page',
  log_out: 'log_out',
  product: 'product',
  product_list: 'product_list',
  album_batch_upload: 'album_batch_upload',
  album_batch_upload_tip_rule: 'album_batch_upload_tip_rule',
  album_batch_upload_drag_hint: 'album_batch_upload_drag_hint',
  album_batch_upload_select_folder: 'album_batch_upload_select_folder',
  album_batch_upload_processing: 'album_batch_upload_processing',
  album_batch_upload_validating: 'album_batch_upload_validating',
  album_batch_upload_clear_all: 'album_batch_upload_clear_all',
  album_batch_upload_start: 'album_batch_upload_start',
  album_batch_upload_switch_to_internal:
    'album_batch_upload_switch_to_internal',
  album_batch_upload_switch_to_external:
    'album_batch_upload_switch_to_external',
  album_batch_upload_switch_confirm_title:
    'album_batch_upload_switch_confirm_title',
  album_batch_upload_switch_confirm_content:
    'album_batch_upload_switch_confirm_content',
  album_batch_upload_switch_busy: 'album_batch_upload_switch_busy',
  album_batch_upload_folder_column: 'album_batch_upload_folder_column',
  album_batch_upload_file_count_column: 'album_batch_upload_file_count_column',
  album_batch_upload_failure_summary: 'album_batch_upload_failure_summary',
  album_batch_upload_limit_reached: 'album_batch_upload_limit_reached',
  album_batch_upload_limit_partial: 'album_batch_upload_limit_partial',
  album_batch_upload_invalid_folder: 'album_batch_upload_invalid_folder',
  album_batch_upload_missing_folder: 'album_batch_upload_missing_folder',
  album_batch_upload_product_not_exist: 'album_batch_upload_product_not_exist',
  album_batch_upload_drop_error: 'album_batch_upload_drop_error',
  album_batch_upload_empty_warning: 'album_batch_upload_empty_warning',
  album_batch_upload_all_success: 'album_batch_upload_all_success',
  album_batch_upload_partial_failed: 'album_batch_upload_partial_failed',
  album_batch_upload_file_upload_failed_reason:
    'album_batch_upload_file_upload_failed_reason',
  album_batch_upload_prepare_failed: 'album_batch_upload_prepare_failed',
  album_batch_upload_request_error: 'album_batch_upload_request_error',
  album_batch_upload_validation_error: 'album_batch_upload_validation_error',
  internal_batch_upload: 'internal_batch_upload',
  internal_batch_upload_tip_rule: 'internal_batch_upload_tip_rule',
  internal_batch_upload_drag_hint: 'internal_batch_upload_drag_hint',
  internal_batch_upload_select_folder: 'internal_batch_upload_select_folder',
  internal_batch_upload_processing: 'internal_batch_upload_processing',
  internal_batch_upload_file_count: 'internal_batch_upload_file_count',
  internal_batch_upload_start: 'internal_batch_upload_start',
  internal_batch_upload_uploading: 'internal_batch_upload_uploading',
  internal_batch_upload_limit_reached: 'internal_batch_upload_limit_reached',
  internal_batch_upload_limit_partial: 'internal_batch_upload_limit_partial',
  internal_batch_upload_missing_folder: 'internal_batch_upload_missing_folder',
  internal_batch_upload_drop_error: 'internal_batch_upload_drop_error',
  internal_batch_upload_empty_warning: 'internal_batch_upload_empty_warning',
  internal_batch_upload_file_upload_failed_reason:
    'internal_batch_upload_file_upload_failed_reason',
  internal_batch_upload_prepare_failed: 'internal_batch_upload_prepare_failed',
  internal_batch_upload_all_success: 'internal_batch_upload_all_success',
  internal_batch_upload_partial_failed: 'internal_batch_upload_partial_failed',
  internal_batch_upload_request_error: 'internal_batch_upload_request_error',
  recycle: 'recycle',
  sell_your_bag: 'sell_your_bag',
  quotation_form: 'quotation_form',
  keyword: 'keyword',
  search: 'search',
  reset: 'reset',
  created_time: 'created_time',
  product_pictures: 'product_pictures',
  product_name: 'product_name',
  member_info: 'member_info',
  options: 'options',
  details: 'details',
  member_id: 'member_id',
  email: 'email',
  phone_number: 'phone_number',
  social_media: 'social_media',
  social_handle: 'social_handle',
  accessories: 'accessories',
  add: 'add',
  please_enter: 'please_enter',
  please_enter_remark: 'please_enter_remark',
  please_select: 'please_select',
  please_enter_without_hyphen: 'please_enter_without_hyphen',
  product_category: 'product_category',
  color: 'color',
  material: 'material',
  submit: 'submit',
  stamp: 'stamp',
  rank: 'rank',
  staff: 'staff',
  reception_staff: 'reception_staff',
  product_info: 'product_info',
  quotation_info: 'quotation_info',
  jpy: 'jpy',
  sgd: 'sgd',
  hkd: 'hkd',
  aed: 'aed',
  currency: 'currency',
  recycle_price: 'recycle_price',
  consignment_price: 'consignment_price',
  substitute_price: 'substitute_price',
  deal_price: 'deal_price',
  inventory: 'inventory',
  in_stock: 'in_stock',
  out_of_stock: 'out_of_stock',
  customer_info: 'customer_info',
  customer_info_record_staff_label: 'customer_info_record_staff_label',
  customer_info_record_product_number_label:
    'customer_info_record_product_number_label',
  customer_info_record_store_label: 'customer_info_record_store_label',
  customer_info_record_tax_free_label: 'customer_info_record_tax_free_label',
  customer_info_record_country_residence_label:
    'customer_info_record_country_residence_label',
  customer_info_record_visit_reason_label:
    'customer_info_record_visit_reason_label',
  customer_info_record_first_channel_label:
    'customer_info_record_first_channel_label',
  customer_info_record_ai_search_label: 'customer_info_record_ai_search_label',
  customer_info_record_sns_account_label:
    'customer_info_record_sns_account_label',
  customer_info_record_buyer_show_label:
    'customer_info_record_buyer_show_label',
  customer_info_record_official_site_label:
    'customer_info_record_official_site_label',
  customer_info_record_preference_label:
    'customer_info_record_preference_label',
  customer_info_record_detail_label: 'customer_info_record_detail_label',
  customer_info_record_owner_label: 'customer_info_record_owner_label',
  name: 'name',
  other_info: 'other_info',
  note: 'note',
  consulting_source: 'consulting_source',
  successful_operation: 'successful_operation',
  product_qr_code: 'product_qr_code',
  date_range: 'date_range',
  created_by: 'created_by',
  edit: 'edit',
  modify: 'modify',
  back: 'back',
  delete: 'delete',
  cancel: 'cancel',
  confirm: 'confirm',
  are_you_sure_to_delete: 'are_you_sure_to_delete',
  bag_style: 'bag_style',
  type: 'type',
  customer_name: 'customer_name',
  quotation_currency: 'quotation_currency',
  inventory_info: 'inventory_info',
  customer_email: 'customer_email',
  product_add: 'product_add',
  japan: 'japan',
  hongkong: 'hongkong',
  singapore: 'singapore',
  dubai: 'dubai',
  france: 'france',
  france_store: 'france_store',
  new_york: 'new_york',
  new_york_store: 'new_york_store',
  stock_place: 'stock_place',
  publish_status: 'publish_status',
  on_shelf: 'on_shelf',
  off_shelf: 'off_shelf',
  on_sale: 'on_sale',
  product_sn: 'product_sn',
  price: 'price',
  price_tax_free: 'price_tax_free',
  brand: 'brand',
  website: 'website',
  ginza: 'ginza',
  sns: 'sns',
  is_trade_in: 'is_trade_in',
  is_real_bag: 'is_real_bag',
  is_fake_bag: 'is_fake_bag',
  select_real_or_fake_bag: 'select_real_or_fake_bag',
  ai_identify_manual_review_notice: 'ai_identify_manual_review_notice',
  created_from: 'created_from',
  product_type: 'product_type',
  consignment: 'consignment',
  yes: 'yes',
  no: 'no',
  tax_free_present: 'tax_free_present',
  tax_free_absent: 'tax_free_absent',
  product_source: 'product_source',
  inventory_source: 'inventory_source',
  original_price: 'original_price',
  rank_desc: 'rank_desc',
  hue: 'hue',
  color_remark: 'color_remark',
  material_remark: 'material_remark',
  hardware: 'hardware',
  hardware_remark: 'hardware_remark',
  stamp_remark: 'stamp_remark',
  measurement: 'measurement',
  list_title: 'list_title',
  list_remark: 'list_remark',
  detail_title: 'detail_title',
  detailed_page_description: 'detailed_page_description',
  collections: 'collections',
  view: 'view',
  product_main_image: 'product_main_image',
  confirm_submit: 'confirm_submit',
  required_field: 'required_field',
  member: 'member',
  member_list: 'member_list',
  member_level: 'member_level',
  total_pay_amount: 'total_pay_amount',
  points: 'points',
  registration_time: 'registration_time',
  first_name: 'first_name',
  last_name: 'last_name',
  gender: 'gender',
  rather_not_say: 'rather_not_say',
  male: 'male',
  female: 'female',
  first_name_katakana: 'first_name_katakana',
  last_name_katakana: 'last_name_katakana',
  birthday: 'birthday',
  points_expiration_time: 'points_expiration_time',
  country_region: 'country_region',
  state_province_city: 'state_province_city',
  detail_address: 'detail_address',
  order_list: 'order_list',
  order_sn: 'order_sn',
  pay_amount: 'pay_amount',
  order_status: 'order_status',
  point_history: 'point_history',
  member_operate_history: 'member_operate_history',
  member_login_history: 'member_login_history',
  login_type: 'login_type',
  login_method: 'login_method',
  login_ip: 'login_ip',
  operate_type: 'operate_type',
  operate_source: 'operate_source',
  change_details: 'change_details',
  field_name: 'field_name',
  old_value: 'old_value',
  new_value: 'new_value',
  change_amount: 'change_amount',
  operator: 'operator',
  shipping_address: 'shipping_address',
  zip_code: 'zip_code',
  default_address: 'default_address',
  password: 'password',
  repeat_password: 'repeat_password',
  member_sign_up: 'member_sign_up',
  order: 'order',
  order_submitted: 'order_submitted',
  order_paid: 'order_paid',
  shipped: 'shipped',
  completed: 'completed',
  platform_delivery: 'platform_delivery',
  modify_recipient_information: 'modify_recipient_information',
  modify_mailing_information: 'modify_mailing_information',
  remark: 'remark',
  operation_remark: 'operation_remark',
  basic_info: 'basic_info',
  member_account: 'member_account',
  delivery_method: 'delivery_method',
  shipment_number: 'shipment_number',
  points_for_order: 'points_for_order',
  order_operation: 'order_operation',
  recipient_information: 'recipient_information',
  ship: 'ship',
  complete_order: 'complete_order',
  revert_to_pending_delivery: 'revert_to_pending_delivery',
  confirm_revert_to_pending_delivery: 'confirm_revert_to_pending_delivery',
  revert_to_delivered: 'revert_to_delivered',
  confirm_revert_to_delivered: 'confirm_revert_to_delivered',
  operate_histories: 'operate_histories',
  stock: 'stock',
  close_order: 'close_order',
  bzsNZmtrmS: 'bzsNZmtrmS',
  payment_info: 'payment_info',
  order_total_amount: 'order_total_amount',
  amount_to_be_paid: 'amount_to_be_paid',
  points_deduction: 'points_deduction',
  discount_amounts: 'discount_amounts',
  adjust_promotion: 'adjust_promotion',
  adjust_promotion_paid_hint: 'adjust_promotion_paid_hint',
  adjust_promotion_paid_only_increase: 'adjust_promotion_paid_only_increase',
  adjust_freight: 'adjust_freight',
  enter_freight_amount: 'enter_freight_amount',
  adjust_freight_hint: 'adjust_freight_hint',
  adjust_freight_success: 'adjust_freight_success',
  convert_to_tax_inclusive: 'convert_to_tax_inclusive',
  convert_to_tax_inclusive_hint: 'convert_to_tax_inclusive_hint',
  convert_to_tax_inclusive_success: 'convert_to_tax_inclusive_success',
  tax_difference: 'tax_difference',
  append_use_integration: 'append_use_integration',
  enter_append_use_points: 'enter_append_use_points',
  online_payment_record: 'online_payment_record',
  offline_payment_record: 'offline_payment_record',
  payment_channel: 'payment_channel',
  confirm_adjust_payment_channel: 'confirm_adjust_payment_channel',
  confirm_adjust_payment_amount: 'confirm_adjust_payment_amount',
  payment_status: 'payment_status',
  payment_time: 'payment_time',
  payment_voucher: 'payment_voucher',
  payment_note: 'payment_note',
  confirmor: 'confirmor',
  confirm_time: 'confirm_time',
  reject: 'reject',
  offline_payment_record_confirm: 'offline_payment_record_confirm',
  system: 'system',
  account_list: 'account_list',
  account: 'account',
  last_login_time: 'last_login_time',
  shop: 'shop',
  log_in: 'log_in',
  create_order: 'create_order',
  zMANYPXpGr: 'zMANYPXpGr',
  XeaiVflJZJ: 'XeaiVflJZJ',
  order_detail: 'order_detail',
  payment_currency: 'payment_currency',
  aVYeAxIbsh: 'aVYeAxIbsh',
  used_points: 'used_points',
  equivalent_to: 'equivalent_to',
  lXECTXrLEx: 'lXECTXrLEx',
  convert_to_jpy: 'convert_to_jpy',
  total_amount: 'total_amount',
  points_earned: 'points_earned',
  points_equivalent: 'points_equivalent',
  LabelList: 'LabelList',
  modify_points: 'modify_points',
  start: 'start',
  end: 'end',
  add_price_tag: 'add_price_tag',
  batch_print: 'batch_print',
  print: 'print',
  sales_code: 'sales_code',
  edit_price_tag: 'edit_price_tag',
  price_tag_preview: 'price_tag_preview',
  price_tag_tip: 'price_tag_tip',
  select_a_maximum_of_three: 'select_a_maximum_of_three',
  select_a_maximum_of_two: 'select_a_maximum_of_two',
  preview: 'preview',
  product_name_1: 'product_name_1',
  price_1: 'price_1',
  option: 'option',
  duplicate_item_number: 'duplicate_item_number',
  MultiplePayList: 'MultiplePayList',
  MultiplePayListSet: 'MultiplePayListSet',
  sortId: 'sortId',
  needPayAmount: 'needPayAmount',
  orderPayId: 'orderPayId',
  Auto: 'Auto',
  AutoSplit: 'AutoSplit',
  saveFirst: 'saveFirst',
  cate_no: 'cate_no',
  category_name: 'category_name',
  level: 'level',
  navigation_bar: 'navigation_bar',
  sidebar_filter: 'sidebar_filter',
  sort: 'sort',
  set_up: 'set_up',
  check_subordinates: 'check_subordinates',
  enable: 'enable',
  disable: 'disable',
  addTo: 'addTo',
  classification_description: 'classification_description',
  category_name_En: 'category_name_En',
  category_name_Ja: 'category_name_Ja',
  category_name_Cn: 'category_name_Cn',
  category_name_Tw: 'category_name_Tw',
  category_value: 'category_value',
  category_ancestor: 'category_ancestor',
  category_parent: 'category_parent',
  size_En: 'size_En',
  size_Ja: 'size_Ja',
  size_Cn: 'size_Cn',
  size_Tw: 'size_Tw',
  category_nav_status: 'category_nav_status',
  category_filter_status: 'category_filter_status',
  category_enable: 'category_enable',
  category_icon: 'category_icon',
  extension_configuration_json: 'extension_configuration_json',
  cate_options: 'cate_options',
  product_categories: 'product_categories',
  no_superior_classification: 'no_superior_classification',
  ojMPRgDisg: 'ojMPRgDisg',
  kkIwEnEVml: 'kkIwEnEVml',
  ginza_shop: 'ginza_shop',
  hongkong_shop: 'hongkong_shop',
  singapore_shop: 'singapore_shop',
  singapore_shop_asu_gst: 'singapore_shop_asu_gst',
  product_list_mobile: 'product_list_mobile',
  support_cryptocurrency_payments: 'support_cryptocurrency_payments',
  set_the: 'set_the',
  main_image: 'main_image',
  total_products: 'total_products',
  copy_link: 'copy_link',
  add_sales_link: 'add_sales_link',
  expired_hours: 'expired_hours',
  print_prompt: 'print_prompt',
  print_position: 'print_position',
  print_settings: 'print_settings',
  order_type: 'order_type',
  order_list_mobile: 'order_list_mobile',
  order_total: 'order_total',
  pending_payment: 'pending_payment',
  pending_payment_r: 'pending_payment_r',
  payment_processed: 'payment_processed',
  all_orders: 'all_orders',
  member_details: 'member_details',
  scan_member_qr: 'scan_member_qr',
  scan_member_qr_hint: 'scan_member_qr_hint',
  member_qr_not_found: 'member_qr_not_found',
  member_qr_invalid: 'member_qr_invalid',
  member_select_mode_scan: 'member_select_mode_scan',
  member_select_mode_manual: 'member_select_mode_manual',
  product_selection: 'product_selection',
  payment_settings: 'payment_settings',
  phone_or_email: 'phone_or_email',
  sku_or_keywords: 'sku_or_keywords',
  enter_use_points: 'enter_use_points',
  use_points: 'use_points',
  enter_discount_amount: 'enter_discount_amount',
  multiple_pay_count: 'multiple_pay_count',
  first_amount: 'first_amount',
  add_multi_amount: 'add_multi_amount',
  add_pay_amount: 'add_pay_amount',
  clear: 'clear',
  generate: 'generate',
  to_order_details: 'to_order_details',
  pay_count: 'pay_count',
  text_lg: 'text_lg',
  maximum_limit_per_transaction: 'maximum_limit_per_transaction',
  transaction_range: 'transaction_range',
  recycling_consignment_order_history: 'recycling_consignment_order_history',
  shop_id: 'shop_id',
  email_history: 'email_history',
  subject: 'subject',
  content: 'content',
  send_time: 'send_time',
  appointment_management_list: 'appointment_management_list',
  appointment_management_config: 'appointment_management_config',
  contract_order: 'contract_order',
  intentional_order: 'intentional_order',
  all: 'all',
  sell_consignment: 'sell_consignment',
  sell: 'sell',
  order_progress: 'order_progress',
  inquiry_order: 'inquiry_order',
  priority: 'priority',
  collapse: 'collapse',
  expand: 'expand',
  pending_initial_appraisal: 'pending_initial_appraisal',
  initial_appraisal: 'initial_appraisal',
  dispatched: 'dispatched',
  pending_final_appraisal: 'pending_final_appraisal',
  pending_customer_confirmation: 'pending_customer_confirmation',
  on_consignment: 'on_consignment',
  pending_return: 'pending_return',
  valuation_expired: 'valuation_expired',
  transaction_completed: 'transaction_completed',
  quoted_amount: 'quoted_amount',
  initial_appraisal_submission_time: 'initial_appraisal_submission_time',
  agreed_initial_appraisal_time: 'agreed_initial_appraisal_time',
  quotation_time: 'quotation_time',
  contract_establishment_time: 'contract_establishment_time',
  pending_payment_amount: 'pending_payment_amount',
  confirmation_settlement_time: 'confirmation_settlement_time',
  cancellation_reason: 'cancellation_reason',
  cancellation_time: 'cancellation_time',
  completion_time: 'completion_time',
  instant_sale: 'instant_sale',
  consignment_preliminary_valuation: 'consignment_preliminary_valuation',
  waiting_store_arrival: 'waiting_store_arrival',
  upload_packing_slip: 'upload_packing_slip',
  confirm_receipt: 'confirm_receipt',
  consignment_pending: 'consignment_pending',
  consignment_in_progress: 'consignment_in_progress',
  recycling_confirmation_quote: 'recycling_confirmation_quote',
  consignment_confirmation_quote: 'consignment_confirmation_quote',
  final_quote: 'final_quote',
  confirm_settlement: 'confirm_settlement',
  modify_quote: 'modify_quote',
  upload_payment_proof: 'upload_payment_proof',
  confirm_return: 'confirm_return',
  re_evaluate: 're_evaluate',
  cancelled: 'cancelled',
  payment_made: 'payment_made',
  preliminary_valuation_completed: 'preliminary_valuation_completed',
  submit_preliminary_valuation: 'submit_preliminary_valuation',
  product_information: 'product_information',
  service_comments: 'service_comments',
  inventory_notes: 'inventory_notes',
  historical_valuation: 'historical_valuation',
  save_and_copy: 'save_and_copy',
  quote: 'quote',
  email_notes: 'email_notes',
  select_at_least_one: 'select_at_least_one',
  filled_in_at_least_one: 'filled_in_at_least_one',
  consignment_valuation_minimum: 'consignment_valuation_minimum',
  consignment_valuation_w: 'consignment_valuation_w',
  consignment_valuation_maximum: 'consignment_valuation_maximum',
  fill_in_completely: 'fill_in_completely',
  invalid_range: 'invalid_range',
  cancel_order: 'cancel_order',
  confirm_cancel_pending_delivery: 'confirm_cancel_pending_delivery',
  intention_confirmation_time: 'intention_confirmation_time',
  contract_confirmation_time: 'contract_confirmation_time',
  cancel_order_time: 'cancel_order_time',
  transaction_completed_time: 'transaction_completed_time',
  associated_sales_order: 'associated_sales_order',
  associated_product_id: 'associated_product_id',
  channel: 'channel',
  id_passport_number: 'id_passport_number',
  user_submitted_product_info: 'user_submitted_product_info',
  product_image_gallery: 'product_image_gallery',
  genuine_product_info: 'genuine_product_info',
  valuation_information: 'valuation_information',
  initial_appraisal_time: 'initial_appraisal_time',
  quotation_confirmation_time: 'quotation_confirmation_time',
  postal_code: 'postal_code',
  mailing_information: 'mailing_information',
  cargo_information: 'cargo_information',
  receiving_status: 'receiving_status',
  receipt_photo: 'receipt_photo',
  receiving_time: 'receiving_time',
  recipient: 'recipient',
  logistics_information: 'logistics_information',
  modify_logistics_information: 'modify_logistics_information',
  modify_basic_info: 'modify_basic_info',
  modify_order_times: 'modify_order_times',
  update_valuation_information: 'update_valuation_information',
  return_information: 'return_information',
  express_company_name: 'express_company_name',
  tracking_number: 'tracking_number',
  return_type: 'return_type',
  return_time: 'return_time',
  payment_information: 'payment_information',
  update_payment_information: 'update_payment_information',
  receiving_account: 'receiving_account',
  payment_type: 'payment_type',
  location: 'location',
  bank_name: 'bank_name',
  bank_address: 'bank_address',
  account_holder_name: 'account_holder_name',
  account_number: 'account_number',
  account_holder_address: 'account_holder_address',
  bank_transfer: 'bank_transfer',
  payment_method: 'payment_method',
  overseas_account: 'overseas_account',
  hong_kong_account: 'hong_kong_account',
  japanese_account: 'japanese_account',
  singapore_account: 'singapore_account',
  account_number_iban: 'account_number_iban',
  identifier: 'identifier',
  number: 'number',
  paynow: 'paynow',
  bank_code: 'bank_code',
  contact_number: 'contact_number',
  payment_amount: 'payment_amount',
  fps: 'fps',
  contract_information: 'contract_information',
  contract_expiry_time: 'contract_expiry_time',
  contract_content: 'contract_content',
  contract_status: 'contract_status',
  customer_version: 'customer_version',
  store_version: 'store_version',
  operation_log: 'operation_log',
  modification_operation_record: 'modification_operation_record',
  operation_content: 'operation_content',
  operation_time: 'operation_time',
  send_email: 'send_email',
  select_template: 'select_template',
  select_language: 'select_language',
  english: 'english',
  chinese: 'chinese',
  japanese: 'japanese',
  body: 'body',
  logistics_certificate: 'logistics_certificate',
  received_items: 'received_items',
  caution: 'caution',
  confirm_submission: 'confirm_submission',
  save_basic_information: 'save_basic_information',
  save_payee_info: 'save_payee_info',
  payee_information: 'payee_information',
  save_success: 'save_success',
  final_quote_successful: 'final_quote_successful',
  final_quote_rejection_successful: 'final_quote_rejection_successful',
  previous: 'previous',
  fill_recycling_confirmation_quote: 'fill_recycling_confirmation_quote',
  contract_type: 'contract_type',
  select_contract_type: 'select_contract_type',
  must_include_consignment_confirmation_quote:
    'must_include_consignment_confirmation_quote',
  must_include_recycling_confirmation_quote:
    'must_include_recycling_confirmation_quote',
  cash: 'cash',
  accounting_settlement: 'accounting_settlement',
  submit_final_quote: 'submit_final_quote',
  reason_for_rejection: 'reason_for_rejection',
  consignment_item_amount: 'consignment_item_amount',
  sales_order_number: 'sales_order_number',
  please_confirm: 'please_confirm',
  confirm_payment: 'confirm_payment',
  payment_information_collection: 'payment_information_collection',
  receiving_amount: 'receiving_amount',
  return_information_collection: 'return_information_collection',
  copy_return_information: 'copy_return_information',
  return_method: 'return_method',
  in_store_pickup: 'in_store_pickup',
  mail: 'mail',
  return_receipt: 'return_receipt',
  submission_time: 'submission_time',
  available_points: 'available_points',
  sell_your_bag_order: 'sell_your_bag_order',
  inquiry_order_progress: 'inquiry_order_progress',
  intentional_order_progress: 'intentional_order_progress',
  contract_order_progress: 'contract_order_progress',
  upload_shiplable: 'upload_shiplable',
  stock_availability: 'stock_availability',
  available: 'available',
  unavailable: 'unavailable',
  traditional_chinese: 'traditional_chinese',
  language_zh_tw: 'language_zh_tw',
  language_zh_cn: 'language_zh_cn',
  language_en: 'language_en',
  language_ja: 'language_ja',
  final_payment_settlement: 'final_payment_settlement',
  copy_order_link: 'copy_order_link',
  invalid_order: 'invalid_order',
  auto_publish: 'auto_publish',
  view_packaging_materials_certificate: 'view_packaging_materials_certificate',
  historical_documents: 'historical_documents',
  packaging_materials_required: 'packaging_materials_required',
  initial_appraisal_o: 'initial_appraisal_o',
  checkout_counter: 'checkout_counter',
  select_member: 'select_member',
  enter_item_number: 'enter_item_number',
  select_member_keyword: 'select_member_keyword',
  price_type: 'price_type',
  tax_inclusive: 'tax_inclusive',
  tax_free: 'tax_free',
  tax_amount: 'tax_amount',
  cash_payment: 'cash_payment',
  third_party_payment: 'third_party_payment',
  other_payment_methods: 'other_payment_methods',
  stock_place_warning_1: 'stock_place_warning_1',
  stock_place_warning_2: 'stock_place_warning_2',
  discount_details: 'discount_details',
  price_adjustment: 'price_adjustment',
  total: 'total',
  discounted: 'discounted',
  add_payment: 'add_payment',
  clear_payment_data: 'clear_payment_data',
  clear_order: 'clear_order',
  non_deposit: 'non_deposit',
  deposit: 'deposit',
  remaining_amount: 'remaining_amount',
  enter_payment_information: 'enter_payment_information',
  select_representative: 'select_representative',
  select_items: 'select_items',
  order_amount: 'order_amount',
  today: 'today',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday',
  appointment_overview: 'appointment_overview',
  weekly_appointments_total: 'weekly_appointments_total',
  arrived: 'arrived',
  booked: 'booked',
  no_show: 'no_show',
  appointment_arrival_time: 'appointment_arrival_time',
  quantity_of_products: 'quantity_of_products',
  status: 'status',
  appointment_details: 'appointment_details',
  copy: 'copy',
  appointment_number: 'appointment_number',
  no_new_appointments_allowed: 'no_new_appointments_allowed',
  appointment_time_slot: 'appointment_time_slot',
  appointment_method: 'appointment_method',
  product_photos: 'product_photos',
  default_tab: 'default_tab',
  bag_authentication: 'bag_authentication',
  authentication_no: 'authentication_no',
  authentication_detail_title: 'authentication_detail_title',
  authentication_report_title: 'authentication_report_title',
  authentication_detail_fetch_failed: 'authentication_detail_fetch_failed',
  authentication_no_copied: 'authentication_no_copied',
  authentication_status_completed: 'authentication_status_completed',
  authentication_status_processing: 'authentication_status_processing',
  authentication_status_queued: 'authentication_status_queued',
  authentication_status_failed: 'authentication_status_failed',
  authentication_status_unknown: 'authentication_status_unknown',
  authentication_detail_not_found: 'authentication_detail_not_found',
  authentication_product_image: 'authentication_product_image',
  authentication_product: 'authentication_product',
  authentication_conclusion: 'authentication_conclusion',
  authentication_ai_summary: 'authentication_ai_summary',
  authentication_valid_detection_points:
    'authentication_valid_detection_points',
  authentication_ai_result: 'authentication_ai_result',
  authentication_score_label: 'authentication_score_label',
  authentication_genuine_result: 'authentication_genuine_result',
  authentication_suspected_fake_manual_review:
    'authentication_suspected_fake_manual_review',
  authentication_point_passed: 'authentication_point_passed',
  authentication_point_failed: 'authentication_point_failed',
  authentication_point_not_found: 'authentication_point_not_found',
  authentication_score_point: 'authentication_score_point',
  authentication_score_zero: 'authentication_score_zero',
  authentication_score_full: 'authentication_score_full',
  authentication_year: 'authentication_year',
  authentication_no_image: 'authentication_no_image',
  xiaoma_authentication: 'xiaoma_authentication',
  no_authentication_result: 'no_authentication_result',
  view_details: 'view_details',
  unbind_authentication_task: 'unbind_authentication_task',
  unbind_authentication_confirm_title: 'unbind_authentication_confirm_title',
  unbind_authentication_confirm_content:
    'unbind_authentication_confirm_content',
  unbind_authentication_success: 'unbind_authentication_success',
  unbind_authentication_failed: 'unbind_authentication_failed',
  bind_authentication_result: 'bind_authentication_result',
  bind_authentication_search_placeholder:
    'bind_authentication_search_placeholder',
  bind_authentication_no_result: 'bind_authentication_no_result',
  bind_authentication_confirm_title: 'bind_authentication_confirm_title',
  bind_authentication_confirm_content: 'bind_authentication_confirm_content',
  bind_authentication_success: 'bind_authentication_success',
  bind_authentication_failed: 'bind_authentication_failed',
  bind_authentication_bind: 'bind_authentication_bind',
  bound_authentication_summary: 'bound_authentication_summary',
  bound_authentication_summary_loading: 'bound_authentication_summary_loading',
  authentication_task_created_time: 'authentication_task_created_time',
  ai_identify: 'ai_identify',
  ai_identify_completed: 'ai_identify_completed',
  ai_identify_failed: 'ai_identify_failed',
  ai_identify_processing_notice: 'ai_identify_processing_notice',
  ai_identify_result_fetch_failed: 'ai_identify_result_fetch_failed',
  ai_identify_upload_failed: 'ai_identify_upload_failed',
  ai_identify_delete_failed: 'ai_identify_delete_failed',
  ai_identify_upload_first: 'ai_identify_upload_first',
  ai_identify_upload_required: 'ai_identify_upload_required',
  ai_identify_pending_upload_warning: 'ai_identify_pending_upload_warning',
  ai_identify_no_image_paths: 'ai_identify_no_image_paths',
  ai_identify_task_submitted: 'ai_identify_task_submitted',
  ai_identify_submit_failed: 'ai_identify_submit_failed',
  ai_identify_processing: 'ai_identify_processing',
  ai_identify_processing_hint: 'ai_identify_processing_hint',
  ai_identify_refresh_result: 'ai_identify_refresh_result',
  ai_identify_start: 'ai_identify_start',
  ai_identify_unsupported_bag: 'ai_identify_unsupported_bag',
  ai_identify_select_category_tip: 'ai_identify_select_category_tip',
  ai_identify_zone_front: 'ai_identify_zone_front',
  ai_identify_zone_logo_handle: 'ai_identify_zone_logo_handle',
  ai_identify_zone_fish_mouth: 'ai_identify_zone_fish_mouth',
  ai_identify_zone_edge_oil_top: 'ai_identify_zone_edge_oil_top',
  ai_identify_zone_full_stamp: 'ai_identify_zone_full_stamp',
  ai_identify_zone_pleat_joint: 'ai_identify_zone_pleat_joint',
  ai_identify_zone_strap_buckle: 'ai_identify_zone_strap_buckle',
  ai_identify_zone_strap_stamp: 'ai_identify_zone_strap_stamp',
  ai_identify_zone_bottom_studs: 'ai_identify_zone_bottom_studs',
  ai_identify_zone_zipper: 'ai_identify_zone_zipper',
  ai_identify_zone_zipper_end: 'ai_identify_zone_zipper_end',
  ai_identify_zone_lock_bottom: 'ai_identify_zone_lock_bottom',
  ai_identify_zone_key: 'ai_identify_zone_key',
  ai_identify_zone_logo: 'ai_identify_zone_logo',
  ai_identify_zone_handle_stitching: 'ai_identify_zone_handle_stitching',
  ai_identify_zone_strap_hardware_engraving:
    'ai_identify_zone_strap_hardware_engraving',
  ai_identify_zone_inner_leather_hardware:
    'ai_identify_zone_inner_leather_hardware',
  ai_identify_zone_h_buckle: 'ai_identify_zone_h_buckle',
  ai_identify_zone_edge_oil_wave: 'ai_identify_zone_edge_oil_wave',
  ai_identify_zone_edge_oil_side: 'ai_identify_zone_edge_oil_side',
  ai_identify_zone_metal_stamp: 'ai_identify_zone_metal_stamp',
  ai_identify_zone_strap_stitch_join: 'ai_identify_zone_strap_stitch_join',
  ai_identify_zone_magnetic_buckle: 'ai_identify_zone_magnetic_buckle',
  ai_identify_zone_magnetic_groove: 'ai_identify_zone_magnetic_groove',
  ai_identify_insufficient_points: 'ai_identify_insufficient_points',
  ai_identify_insufficient_points_hint: 'ai_identify_insufficient_points_hint',
  ai_identify_few_sample_positive: 'ai_identify_few_sample_positive',
  add_appointment_information: 'add_appointment_information',
  fill_in_customer_name: 'fill_in_customer_name',
  fill_in_phone_number: 'fill_in_phone_number',
  fill_in_email: 'fill_in_email',
  search_member_information: 'search_member_information',
  appointment_date_configuration: 'appointment_date_configuration',
  date: 'date',
  time_slot: 'time_slot',
  payment_completed: 'payment_completed',
  goods_received: 'goods_received',
  normal_transaction: 'normal_transaction',
  in_effect: 'in_effect',
  user: 'user',
  appointment_information: 'appointment_information',
  unused: 'unused',
  secondhand: 'secondhand',
  consignment_valuation: 'consignment_valuation',
  recycling_valuation: 'recycling_valuation',
  manual_addition: 'manual_addition',
  appointment_slot_editing: 'appointment_slot_editing',
  cryptocurrency_payment_records: 'cryptocurrency_payment_records',
  third_party_transaction_id: 'third_party_transaction_id',
  payment_link: 'payment_link',
  cryptocurrency_amount: 'cryptocurrency_amount',
  quantity: 'quantity',
  cancel_appointment: 'cancel_appointment',
  code: 'code',
  selling_price: 'selling_price',
  purchase_price: 'purchase_price',
  procurement: 'procurement',
  facebookEnabled: 'facebookEnabled',
  zh_CN: 'zh_CN',
  zh_TW: 'zh_TW',
  ja: 'ja',
  en: 'en',
  Hardware: 'Hardware',
  Minor_scratches: 'Minor_scratches',
  Small_scratches: 'Small_scratches',
  Scratches: 'Scratches',
  The_hardware_has_no_protective_film: 'The_hardware_has_no_protective_film',
  The_hardware_has_the_original_protective_film:
    'The_hardware_has_the_original_protective_film',
  Edges: 'Edges',
  Slight_scuff_on_all_corners: 'Slight_scuff_on_all_corners',
  Scuff_on_all_corners: 'Scuff_on_all_corners',
  Slight_stains_on_all_corners: 'Slight_stains_on_all_corners',
  Stains_on_all_corners: 'Stains_on_all_corners',
  Slight_scuff_on_corner: 'Slight_scuff_on_corner',
  Scuff_on_corner: 'Scuff_on_corner',
  Slight_stains_on_corner: 'Slight_stains_on_corner',
  Stains_on_corner: 'Stains_on_corner',
  Outer: 'Outer',
  Overall_slight_signs_of_use: 'Overall_slight_signs_of_use',
  Overall_signs_of_use: 'Overall_signs_of_use',
  Outer_slight_scratches_from_use: 'Outer_slight_scratches_from_use',
  Outer_normal_scratches_from_use: 'Outer_normal_scratches_from_use',
  Overall_slight_deformation: 'Overall_slight_deformation',
  Overall_deformation: 'Overall_deformation',
  Overall_slight_stains: 'Overall_slight_stains',
  Overall_stains: 'Overall_stains',
  Inner: 'Inner',
  Inner_slight_signs_of_use: 'Inner_slight_signs_of_use',
  Inner_signs_of_use: 'Inner_signs_of_use',
  Inner_slight_stains: 'Inner_slight_stains',
  Inner_stains: 'Inner_stains',
  Slight_indentations_from_use: 'Slight_indentations_from_use',
  Normal_indentations_from_use: 'Normal_indentations_from_use',
  Indentations: 'Indentations',
  Slight_scratches_from_use: 'Slight_scratches_from_use',
  Normal_scratches_from_use: 'Normal_scratches_from_use',
  Ink_marks: 'Ink_marks',
  Odor: 'Odor',
  Handle: 'Handle',
  Handle_small_scratches: 'Handle_small_scratches',
  Handle_scratches: 'Handle_scratches',
  Slight_stains_on_the_handle: 'Slight_stains_on_the_handle',
  Stains_on_the_handle: 'Stains_on_the_handle',
  Deformation: 'Deformation',
  Discoloration: 'Discoloration',
  Slight_peeling_on_the_edge: 'Slight_peeling_on_the_edge',
  Highlights: 'Highlights',
  Discontinued_model: 'Discontinued_model',
  Discontinued_leather: 'Discontinued_leather',
  No_deformation_on_the_body: 'No_deformation_on_the_body',
  Protective_film_on_the_bottom_studs: 'Protective_film_on_the_bottom_studs',
  Protective_film_on_the_metal_parts: 'Protective_film_on_the_metal_parts',
  Interior_is_clean_no_scratches: 'Interior_is_clean_no_scratches',
  No_wear_on_the_corners: 'No_wear_on_the_corners',
  one_click_translation: 'one_click_translation',
  add_member: 'add_member',
  front: 'front',
  back1: 'back1',
  interior: 'interior',
  blind_stamp: 'blind_stamp',
  signs_of_wear: 'signs_of_wear',
  upload_more: 'upload_more',
  required: 'required',
  select_address: 'select_address',
  enter_address_manually: 'enter_address_manually',
  valuation: 'valuation',
  consignment_contract: 'consignment_contract',
  recovery_contract: 'recovery_contract',
  one_click_completion: 'one_click_completion',
  unconfirmed: 'unconfirmed',
  create_sales_order: 'create_sales_order',
  creating_recycling_consignment_sales_contract:
    'creating_recycling_consignment_sales_contract',
  creating_intent_order_for_recycling_consignment_sales:
    'creating_intent_order_for_recycling_consignment_sales',
  print_receipt: 'print_receipt',
  coupon: 'coupon',
  enter_the_coupon: 'enter_the_coupon',
  order_source: 'order_source',
  exclude_b2b_orders: 'exclude_b2b_orders',
  item: 'item',
  enter_order_source: 'enter_order_source',
  hint: 'hint',
  changes_have_not_been_saved: 'changes_have_not_been_saved',
  jVFAzYMWJd: 'jVFAzYMWJd',
  JSRDwAEqdy: 'JSRDwAEqdy',
  pqepZTOsNb: 'pqepZTOsNb',
  zYZFfigLSj: 'zYZFfigLSj',
  vDnOozVzna: 'vDnOozVzna',
  kTFIViDbSC: 'kTFIViDbSC',
  PVkdenXCwb: 'PVkdenXCwb',
  AYTHzloOiY: 'AYTHzloOiY',
  print_the_contract: 'print_the_contract',
  please_select_a_member: 'please_select_a_member',
  the_place_of_origin_or_currency_is_incorrect:
    'the_place_of_origin_or_currency_is_incorrect',
  sop: 'sop',
  checkout_counter_sop: 'checkout_counter_sop',
  order_create_sop: 'order_create_sop',
  guest_remarks: 'guest_remarks',
  contract: 'contract',
  receipt: 'receipt',
  consignment_orders_and: 'consignment_orders_and',
  freight: 'freight',
  manual_freight: 'manual_freight',
  freight_waiver_domestic: 'freight_waiver_domestic',
  freight_waiver_member: 'freight_waiver_member',
  please_select_a_shipping_address: 'please_select_a_shipping_address',
  add_address: 'add_address',
  show_to_the_guest: 'show_to_the_guest',
  supports_up_to_18_items: 'supports_up_to_18_items',
  address: 'address',
  khvsAbbLJs: 'khvsAbbLJs',
  rank_desc_note: 'rank_desc_note',
  expiration_time: 'expiration_time',
  confirm_invalid_order_change: 'confirm_invalid_order_change',
  invalid_order_points_adjustment: 'invalid_order_points_adjustment',
  pointsMarketing: 'pointsMarketing',
  orderPoints: 'orderPoints',
  registrationPoints: 'registrationPoints',
  pointsName: 'pointsName',
  pointsType: 'pointsType',
  activityPeriod: 'activityPeriod',
  pointsQuantity: 'pointsQuantity',
  collectionTime: 'collectionTime',
  multiplier: 'multiplier',
  recyclingContractOrder: 'recyclingContractOrder',
  consignmentContractOrder: 'consignmentContractOrder',
  noCategoryFound: 'noCategoryFound',
  pricing_rule_1: 'pricing_rule_1',
  pricing_rule_2: 'pricing_rule_2',
  uMihwkqqts: 'uMihwkqqts',
  cWgwnQtBhq: 'cWgwnQtBhq',
  tPZNlIoLIJ: 'tPZNlIoLIJ',
  ZNabMrkXeR: 'ZNabMrkXeR',
  gCfzSuAAFu: 'gCfzSuAAFu',
  qjvTkFPhtS: 'qjvTkFPhtS',
  JTehSPdAjL: 'JTehSPdAjL',
  aDOEGIrhvq: 'aDOEGIrhvq',
  rrooMUILfK: 'rrooMUILfK',
  mhIsJOVuUc: 'mhIsJOVuUc',
  JlnzqcVRbm: 'JlnzqcVRbm',
  bxYXkMWIQe: 'bxYXkMWIQe',
  juusvCbRWo: 'juusvCbRWo',
  ZQDTJFXciM: 'ZQDTJFXciM',
  StzCTlyrrP: 'StzCTlyrrP',
  kUJWWIcHRk: 'kUJWWIcHRk',
  PWWODvsPvK: 'PWWODvsPvK',
  rhCgCypWuW: 'rhCgCypWuW',
  kWaTarLxzT: 'kWaTarLxzT',
  bOYktSqeQU: 'bOYktSqeQU',
  FrlyfzfGME: 'FrlyfzfGME',
  AHBGzxjtrR: 'AHBGzxjtrR',
  category: 'category',
  path: 'path',
  cover: 'cover',
  title: 'title',
  language: 'language',
  article_publish_status: 'article_publish_status',
  updated_time: 'updated_time',
  article_category: 'article_category',
  description: 'description',
  article_content: 'article_content',
  article_list: 'article_list',
  topic_list: 'topic_list',
  topic_category: 'topic_category',
  recommended: 'recommended',
  photo_album: 'photo_album',
  copy_product_to: 'copy_product_to',
  nikkei_table: 'nikkei_table',
  sales_daily_report: 'sales_daily_report',
  sales_management_table: 'sales_management_table',
  sales_date: 'sales_date',
  sales_customer_id: 'sales_customer_id',
  sales_product_id: 'sales_product_id',
  sales_quantity_sold: 'sales_quantity_sold',
  sales_unit_price: 'sales_unit_price',
  'sales_sales_amount_(subtotal)': 'sales_sales_amount_(subtotal)',
  sales_discount_promotion: 'sales_discount_promotion',
  gross_profit: 'gross_profit',
  purchase_price_tax_inclusive: 'purchase_price_tax_inclusive',
  selling_price_tax_inclusive: 'selling_price_tax_inclusive',
  purchase_price_tax_free: 'purchase_price_tax_free',
  selling_price_tax_free: 'selling_price_tax_free',
  gross_profit_tax_free: 'gross_profit_tax_free',
  sales_total: 'sales_total',
  sales_tax: 'sales_tax',
  sales_payment_method: 'sales_payment_method',
  sales_responsible: 'sales_responsible',
  sales_notes: 'sales_notes',
  purchase_daily_report: 'purchase_daily_report',
  consignment_daily_report: 'consignment_daily_report',
  purchase_date: 'purchase_date',
  purchase_product_id: 'purchase_product_id',
  purchase_quantity_purchased: 'purchase_quantity_purchased',
  'purchase_purchase_price_(unit)': 'purchase_purchase_price_(unit)',
  'purchase_purchase_amount_(subtotal)': 'purchase_purchase_amount_(subtotal)',
  purchase_point: 'purchase_point',
  purchase_supplier: 'purchase_supplier',
  purchase_category: 'purchase_category',
  purchase_payment_method: 'purchase_payment_method',
  purchase_responsible: 'purchase_responsible',
  purchase_notes: 'purchase_notes',
  consignment_date: 'consignment_date',
  consignment_product_id: 'consignment_product_id',
  consignment_quantity_consigned: 'consignment_quantity_consigned',
  consignment_consignor: 'consignment_consignor',
  consignment_contract_price: 'consignment_contract_price',
  consignment_selling_price: 'consignment_selling_price',
  consignment_point: 'consignment_point',
  consignment_sales_status: 'consignment_sales_status',
  consignment_payment_method: 'consignment_payment_method',
  consignment_responsible: 'consignment_responsible',
  consignment_notes: 'consignment_notes',
  reference_price: 'reference_price',
  menu_home: 'menu_home',
  menu_rrs: 'menu_rrs',
  menu_chat: 'menu_chat',
  chat_message: 'chat_message',
  chat_setting: 'chat_setting',
  menu_marketing: 'menu_marketing',
  menu_email_template: 'menu_email_template',
  menu_send_email: 'menu_send_email',
  menu_discount_configuration: 'menu_discount_configuration',
  menu_coupon_record: 'menu_coupon_record',
  menu_cms: 'menu_cms',
  menu_seo: 'menu_seo',
  menu_fms: 'menu_fms',
  menu_fms_account: 'menu_fms_account',
  product_want_request: 'product_want_request',
  product_operation_record: 'product_operation_record',
  product_id: 'product_id',
  product_activity_admin: 'product_activity_admin',
  product_activity_member_email: 'product_activity_member_email',
  pwr_create: 'pwr_create',
  pwr_match: 'pwr_match',
  pwr_log: 'pwr_log',
  pwr_phone: 'pwr_phone',
  pwr_category: 'pwr_category',
  pwr_status_pending_followup: 'pwr_status_pending_followup',
  pwr_status_recommended: 'pwr_status_recommended',
  pwr_status_deal_closed: 'pwr_status_deal_closed',
  pwr_status_cancelled: 'pwr_status_cancelled',
  pwr_source: 'pwr_source',
  pwr_source_admin: 'pwr_source_admin',
  pwr_source_app: 'pwr_source_app',
  pwr_source_website: 'pwr_source_website',
  pwr_operate_create: 'pwr_operate_create',
  pwr_status_updated: 'pwr_status_updated',
  pwr_edit_title: 'pwr_edit_title',
  pwr_create_title: 'pwr_create_title',
  pwr_update_success: 'pwr_update_success',
  pwr_create_success: 'pwr_create_success',
  pwr_member_optional: 'pwr_member_optional',
  pwr_please_enter_email: 'pwr_please_enter_email',
  pwr_please_enter_email_or_phone: 'pwr_please_enter_email_or_phone',
  pwr_invalid_email: 'pwr_invalid_email',
  pwr_please_select_category: 'pwr_please_select_category',
  pwr_follow_up_status: 'pwr_follow_up_status',
  pwr_match_drawer_title: 'pwr_match_drawer_title',
  pwr_match_score: 'pwr_match_score',
  pwr_stock_status: 'pwr_stock_status',
  pwr_match_hits: 'pwr_match_hits',
  pwr_hit_category: 'pwr_hit_category',
  pwr_hit_rank: 'pwr_hit_rank',
  pwr_operate_log_title: 'pwr_operate_log_title',
  pwr_change_status: 'pwr_change_status',
  pwr_new_status: 'pwr_new_status',
  pwr_status_remark_placeholder: 'pwr_status_remark_placeholder',
  pwr_send_email: 'pwr_send_email',
  pwr_send_email_success: 'pwr_send_email_success',
  pwr_send_email_no_email: 'pwr_send_email_no_email',
  pwr_send_email_select_products: 'pwr_send_email_select_products',
  pwr_send_email_confirm_title: 'pwr_send_email_confirm_title',
  pwr_send_email_confirm_content: 'pwr_send_email_confirm_content',
  pwr_send_email_ineligible_tip: 'pwr_send_email_ineligible_tip',
  pwr_operate_send_email: 'pwr_operate_send_email',
  pwr_match_for_sale_only: 'pwr_match_for_sale_only',
  email_template_Description: 'email_template_Description',
  email_template_Subject: 'email_template_Subject',
  email_template_Content: 'email_template_Content',
  email_template_English: 'email_template_English',
  email_template_Japanese: 'email_template_Japanese',
  'email_template_Simplified Chinese': 'email_template_Simplified Chinese',
  email_template_Edit_Email_Template: 'email_template_Edit_Email_Template',
  email_template_English_Subject: 'email_template_English_Subject',
  email_template_Japanese_Subject: 'email_template_Japanese_Subject',
  email_template_Simplified_Chinese_Subject:
    'email_template_Simplified_Chinese_Subject',
  email_template_English_content: 'email_template_English_content',
  email_template_Japanese_content: 'email_template_Japanese_content',
  email_template_Simplified_Chinese_content:
    'email_template_Simplified_Chinese_content',
  email_template_Traditional_Chinese_Subject:
    'email_template_Traditional_Chinese_Subject',
  email_template_Traditional_Chinese_content:
    'email_template_Traditional_Chinese_content',
  send_email_Recipient: 'send_email_Recipient',
  send_email_Select_Template: 'send_email_Select_Template',
  send_email_Select_Language: 'send_email_Select_Language',
  send_email_Subject: 'send_email_Subject',
  send_email_Body: 'send_email_Body',
  send_email_Content: 'send_email_Content',
  send_email_Preview: 'send_email_Preview',
  send_email_Send: 'send_email_Send',
  total_orders: 'total_orders',
  total_sales_quantity: 'total_sales_quantity',
  total_order_amount: 'total_order_amount',
  total_discount_amount: 'total_discount_amount',
  purchasing_staff: 'purchasing_staff',
  sales_staff: 'sales_staff',
  sns_discount: 'sns_discount',
  total_tax_amount: 'total_tax_amount',
  total_pay_amount_statistics: 'total_pay_amount_statistics',
  total_cost_by_currency: 'total_cost_by_currency',
  total_gross_profit_by_currency: 'total_gross_profit_by_currency',
  uLsFothaKN: 'uLsFothaKN',
  VFGniMWIir: 'VFGniMWIir',
  bVMfWhvydu: 'bVMfWhvydu',
  role_list: 'role_list',
  role_name: 'role_name',
  assign_menu: 'assign_menu',
  assign_resource: 'assign_resource',
  menu_list: 'menu_list',
  menu_name: 'menu_name',
  menu_level: 'menu_level',
  front_end_name: 'front_end_name',
  display_or_not: 'display_or_not',
  parent_menu: 'parent_menu',
  no_superior_menu: 'no_superior_menu',
  add_submenu: 'add_submenu',
  assign_role: 'assign_role',
  permissions: 'permissions',
  direct_grant: 'direct_grant',
  id_certificate: 'id_certificate',
  payment_details: 'payment_details',
  consignment_total_purchase_quantity: 'consignment_total_purchase_quantity',
  consignment_total_cost_price: 'consignment_total_cost_price',
  consignment_total_price: 'consignment_total_price',
  purchase_total_purchase_quantity: 'purchase_total_purchase_quantity',
  purchase_total_cost_price: 'purchase_total_cost_price',
  profit_report: 'profit_report',
  commission_snapshot: 'commission_snapshot',
  shop_sale_incentive: 'shop_sale_incentive',
  shop_sale_incentive_calculate: 'shop_sale_incentive_calculate',
  shop_sale_incentive_refresh: 'shop_sale_incentive_refresh',
  shop_sale_incentive_year_month: 'shop_sale_incentive_year_month',
  shop_sale_incentive_status: 'shop_sale_incentive_status',
  shop_sale_incentive_status_running: 'shop_sale_incentive_status_running',
  shop_sale_incentive_status_completed: 'shop_sale_incentive_status_completed',
  shop_sale_incentive_status_failed: 'shop_sale_incentive_status_failed',
  shop_sale_incentive_item_count: 'shop_sale_incentive_item_count',
  shop_sale_incentive_calculated_at: 'shop_sale_incentive_calculated_at',
  shop_sale_incentive_error_message: 'shop_sale_incentive_error_message',
  shop_sale_incentive_calculate_modal_title:
    'shop_sale_incentive_calculate_modal_title',
  shop_sale_incentive_please_select_month:
    'shop_sale_incentive_please_select_month',
  shop_sale_incentive_calculate_success:
    'shop_sale_incentive_calculate_success',
  shop_sale_incentive_refresh_confirm_title:
    'shop_sale_incentive_refresh_confirm_title',
  shop_sale_incentive_refresh_confirm_desc:
    'shop_sale_incentive_refresh_confirm_desc',
  shop_sale_incentive_refresh_success: 'shop_sale_incentive_refresh_success',
  shop_sale_incentive_profit: 'shop_sale_incentive_profit',
  shop_sale_incentive_row_type: 'shop_sale_incentive_row_type',
  shop_sale_incentive_row_type_sale: 'shop_sale_incentive_row_type_sale',
  shop_sale_incentive_row_type_refund: 'shop_sale_incentive_row_type_refund',
  shop_sale_incentive_filter_status: 'shop_sale_incentive_filter_status',
  shop_sale_incentive_filter_year_month:
    'shop_sale_incentive_filter_year_month',
  shop_sale_incentive_download: 'shop_sale_incentive_download',
  shop_sale_incentive_summary: 'shop_sale_incentive_summary',
  shop_sale_incentive_summary_sales_amount:
    'shop_sale_incentive_summary_sales_amount',
  shop_sale_incentive_summary_commission:
    'shop_sale_incentive_summary_commission',
  shop_sale_incentive_order_staff: 'shop_sale_incentive_order_staff',
  shop_sale_incentive_purchase_staff: 'shop_sale_incentive_purchase_staff',
  shop_sale_incentive_purchase_reception_staff:
    'shop_sale_incentive_purchase_reception_staff',
  ad_name: 'ad_name',
  ad_placement: 'ad_placement',
  ad_image: 'ad_image',
  online_offline: 'online_offline',
  online: 'online',
  offline: 'offline',
  start_time: 'start_time',
  end_time: 'end_time',
  time: 'time',
  advertisement_list: 'advertisement_list',
  pc_home_page_carousel: 'pc_home_page_carousel',
  app_home_carousel: 'app_home_carousel',
  advertising_space: 'advertising_space',
  ad_link: 'ad_link',
  stock_status_change_note: 'stock_status_change_note',
  PSmonSgnjX: 'PSmonSgnjX',
  arvArlFrfX: 'arvArlFrfX',
  xCWNaTSMxQ: 'xCWNaTSMxQ',
  vucsrXTzfQ: 'vucsrXTzfQ',
  EsqMNViBHq: 'EsqMNViBHq',
  LSyPLaaZjt: 'LSyPLaaZjt',
  dwawuQNUEi: 'dwawuQNUEi',
  SYLYoWTeQq: 'SYLYoWTeQq',
  supports_up_to_n_items: 'supports_up_to_n_items',
  download_excel: 'download_excel',
  download_csv: 'download_csv',
  resource_list: 'resource_list',
  resource_name: 'resource_name',
  resource_path: 'resource_path',
  resource_classification: 'resource_classification',
  FOGRMrNbMM: 'FOGRMrNbMM',
  DXlRCJJEKv: 'DXlRCJJEKv',
  GbYAnWwRFt: 'GbYAnWwRFt',
  consignment_to_recycling: 'consignment_to_recycling',
  recycling_to_consignment: 'recycling_to_consignment',
  recycling_to_consignment_confirm: 'recycling_to_consignment_confirm',
  restore_consignment: 'restore_consignment',
  restore_consignment_confirm: 'restore_consignment_confirm',
  restore_consignment_republish: 'restore_consignment_republish',
  revert_consignment_to_wait_payment: 'revert_consignment_to_wait_payment',
  revert_consignment_to_wait_payment_confirm:
    'revert_consignment_to_wait_payment_confirm',
  cancel_completed_recycle_order: 'cancel_completed_recycle_order',
  cancel_completed_recycle_order_confirm:
    'cancel_completed_recycle_order_confirm',
  cancel_completed_recycle_order_return:
    'cancel_completed_recycle_order_return',
  cancel_completed_recycle_order_direct:
    'cancel_completed_recycle_order_direct',
  cancel_completed_recycle_order_mode_required:
    'cancel_completed_recycle_order_mode_required',
  Hardware_Derivative_Protective_film: 'Hardware_Derivative_Protective_film',
  Hardware_Slightly_oxidised: 'Hardware_Slightly_oxidised',
  Hardware_Oxidised: 'Hardware_Oxidised',
  Hardware_There_will_be_minor_scratches_due_to_the_unique_design_of_the_product:
    'Hardware_There_will_be_minor_scratches_due_to_the_unique_design_of_the_product',
  Outer_Slight_indentations_from_use: 'Outer_Slight_indentations_from_use',
  Outer_Normal_indentations_from_use: 'Outer_Normal_indentations_from_use',
  Outer_Indentations: 'Outer_Indentations',
  Outer_Color_touch_up: 'Outer_Color_touch_up',
  Shoulder_Strap_Small_scratches: 'Shoulder_Strap_Small_scratches',
  Shoulder_Strap_Scratches: 'Shoulder_Strap_Scratches',
  Shoulder_Strap_Slight_indentations_from_use:
    'Shoulder_Strap_Slight_indentations_from_use',
  Shoulder_Strap_Normal_indentations_from_use:
    'Shoulder_Strap_Normal_indentations_from_use',
  Shoulder_Strap_Indentations: 'Shoulder_Strap_Indentations',
  Shoulder_Strap_Slight_stains_on_the_handle:
    'Shoulder_Strap_Slight_stains_on_the_handle',
  Shoulder_Strap_Stains_on_the_handle: 'Shoulder_Strap_Stains_on_the_handle',
  Others_Stains_on_dustbag: 'Others_Stains_on_dustbag',
  shoulder_strap: 'shoulder_strap',
  others: 'others',
  eNxVOVImMN: 'eNxVOVImMN',
  CxeLXsjeRo: 'CxeLXsjeRo',
  KaLvBciebv: 'KaLvBciebv',
  jHkqqeaSOv: 'jHkqqeaSOv',
  rzdMoKAcEc: 'rzdMoKAcEc',
  GqRqjCEQxK: 'GqRqjCEQxK',
  XQTIAmaivc: 'XQTIAmaivc',
  iIJPjfkyBr: 'iIJPjfkyBr',
  KJNCWPDiRG: 'KJNCWPDiRG',
  pTYrCpwbRm: 'pTYrCpwbRm',
  dhDBFGAEfU: 'dhDBFGAEfU',
  UkQnhHkZxc: 'UkQnhHkZxc',
  SAnwKhjJJd: 'SAnwKhjJJd',
  cDYPiRpTxM: 'cDYPiRpTxM',
  consignment_to_recycling_tips: 'consignment_to_recycling_tips',
  attendance: 'attendance',
  AdcTXGDchO: 'AdcTXGDchO',
  attendance_record: 'attendance_record',
  rluYnqBHGi: 'rluYnqBHGi',
  SXpNgLWetM: 'SXpNgLWetM',
  czbRYWhFdZ: 'czbRYWhFdZ',
  ThAdOdLIza: 'ThAdOdLIza',
  qeUzbiaUej: 'qeUzbiaUej',
  brOLzqUFVx: 'brOLzqUFVx',
  DgHjGCYKJD: 'DgHjGCYKJD',
  OFQcWePEsI: 'OFQcWePEsI',
  XQHQaxYgtY: 'XQHQaxYgtY',
  UNcgaTHsci: 'UNcgaTHsci',
  KpQUBrSjzY: 'KpQUBrSjzY',
  yYqvdvcMFh: 'yYqvdvcMFh',
  lzzZmOTmSS: 'lzzZmOTmSS',
  RILmyFVuBj: 'RILmyFVuBj',
  xzgBKptwqF: 'xzgBKptwqF',
  KNCVBZIrFK: 'KNCVBZIrFK',
  GOEpsVQFAo: 'GOEpsVQFAo',
  sHXnOEVSrC: 'sHXnOEVSrC',
  oRDtoUEFuk: 'oRDtoUEFuk',
  KjExOCBoik: 'KjExOCBoik',
  pWpTmJiNfE: 'pWpTmJiNfE',
  UNXRchiSDw: 'UNXRchiSDw',
  XLtWNsvkPj: 'XLtWNsvkPj',
  iJVtIJxKRd: 'iJVtIJxKRd',
  cGWwPIcXWq: 'cGWwPIcXWq',
  ZPgEroRALL: 'ZPgEroRALL',
  NlBduEDffi: 'NlBduEDffi',
  receipt_print_dialog_title: 'receipt_print_dialog_title',
  receipt_print_add_signature_field: 'receipt_print_add_signature_field',
  receipt_print_failed: 'receipt_print_failed',
  UFbYgUaLbn: 'UFbYgUaLbn',
  VrklWxjXqm: 'VrklWxjXqm',
  udIpUVuvzQ: 'udIpUVuvzQ',
  BtxdTZwomQ: 'BtxdTZwomQ',
  rLrlFnIYtn: 'rLrlFnIYtn',
  VGpYRtSykS: 'VGpYRtSykS',
  aSgVoNemkS: 'aSgVoNemkS',
  zduNzCcPrd: 'zduNzCcPrd',
  fkYkkWnfou: 'fkYkkWnfou',
  kuAPzTFDOA: 'kuAPzTFDOA',
  fRPWDZUTrd: 'fRPWDZUTrd',
  uaQuxKzGRJ: 'uaQuxKzGRJ',
  AflpoGEDme: 'AflpoGEDme',
  qbyfzsyRCB: 'qbyfzsyRCB',
  DKdJCTxhPv: 'DKdJCTxhPv',
  GnokRayYvX: 'GnokRayYvX',
  fGoIjqfuGC: 'fGoIjqfuGC',
  chqkPCqMXr: 'chqkPCqMXr',
  XqbmUjmpYX: 'XqbmUjmpYX',
  AazeJZYkLY: 'AazeJZYkLY',
  XJUCNTGPwi: 'XJUCNTGPwi',
  cPPGPUKnlG: 'cPPGPUKnlG',
  ZsRaquEkmw: 'ZsRaquEkmw',
  iVuciTCWOd: 'iVuciTCWOd',
  uiLAygHdsK: 'uiLAygHdsK',
  HVTbgZaqUs: 'HVTbgZaqUs',
  raUNZHBLMO: 'raUNZHBLMO',
  WxlSBxBgJG: 'WxlSBxBgJG',
  Gahtpvbfsb: 'Gahtpvbfsb',
  ABGYpGErys: 'ABGYpGErys',
  shanghai: 'shanghai',
  shanghai_store: 'shanghai_store',
  ANzlMPqMMg: 'ANzlMPqMMg',
  reoMctTcrJ: 'reoMctTcrJ',
  WgIPBPPxEU: 'WgIPBPPxEU',
  KDYOlENnJC: 'KDYOlENnJC',
  rtjLykJLYo: 'rtjLykJLYo',
  OSoMXAfuDT: 'OSoMXAfuDT',
  cmPAiDasco: 'cmPAiDasco',
  vAlezYsIhZ: 'vAlezYsIhZ',
  SDZFKhLlBN: 'SDZFKhLlBN',
  zjuDSagfzW: 'zjuDSagfzW',
  ZdIlKfghFw: 'ZdIlKfghFw',
  BjbkDXQZio: 'BjbkDXQZio',
  nRSvSaqzoU: 'nRSvSaqzoU',
  DSLcOTUUkJ: 'DSLcOTUUkJ',
  IkySOQOafS: 'IkySOQOafS',
  SELUBgAXat: 'SELUBgAXat',
  gLZdxIjJCz: 'gLZdxIjJCz',
  ishbjCMUuX: 'ishbjCMUuX',
  SUBnmTXEMr: 'SUBnmTXEMr',
  QFfPqqZTdg: 'QFfPqqZTdg',
  QzKqkShCkV: 'QzKqkShCkV',
  TRxWQqlkRk: 'TRxWQqlkRk',
  cttOzykqKj: 'cttOzykqKj',
  vZEqAfLzsH: 'vZEqAfLzsH',
  SHWLMrmyez: 'SHWLMrmyez',
  xSEiAdbHmA: 'xSEiAdbHmA',
  umeda: 'umeda',
  umeda_store: 'umeda_store',
  dubai_store: 'dubai_store',
  CXvOjSxLCk: 'CXvOjSxLCk',
  LbzqprQLMq: 'LbzqprQLMq',
  TlTJwaQjAw: 'TlTJwaQjAw',
  HMCYidBcAe: 'HMCYidBcAe',
  WjgqGyexJK: 'WjgqGyexJK',
  QgLQqEnUhS: 'QgLQqEnUhS',
  psXrohmSEt: 'psXrohmSEt',
  bnVjfMaqXl: 'bnVjfMaqXl',
  ppxlGSAMoY: 'ppxlGSAMoY',
  delivery_time: 'delivery_time',
  complete_time: 'complete_time',
  rmRaikouFN: 'rmRaikouFN',
  daily_statistics_report: 'daily_statistics_report',
  shop_cash: 'shop_cash',
  YrUIIgiGqm: 'YrUIIgiGqm',
  QXVWPTZqEt: 'QXVWPTZqEt',
  PVfpzNPNmJ: 'PVfpzNPNmJ',
  QIXxrHAzgP: 'QIXxrHAzgP',
  MZYosCkjLE: 'MZYosCkjLE',
  RYvLthfSdv: 'RYvLthfSdv',
  cash_payment_total: 'cash_payment_total',
  VUDsYnEswz: 'VUDsYnEswz',
  no_cash_payments_today: 'no_cash_payments_today',
  recycled_consignment_cash_settlement: 'recycled_consignment_cash_settlement',
  order_count: 'order_count',
  recycled_consignment_cash_total: 'recycled_consignment_cash_total',
  no_recycled_consignment_cash_payments_today:
    'no_recycled_consignment_cash_payments_today',
  bgiJBNBpWz: 'bgiJBNBpWz',
  beginning_cash: 'beginning_cash',
  treasury_cash_movement: 'treasury_cash_movement',
  treasury_cash_in: 'treasury_cash_in',
  treasury_cash_out: 'treasury_cash_out',
  treasury_cash_movement_net: 'treasury_cash_movement_net',
  treasury_cash_both_directions_error: 'treasury_cash_both_directions_error',
  sale_cash_total: 'sale_cash_total',
  recycled_consignment_cash_used: 'recycled_consignment_cash_used',
  system_cash_sales: 'system_cash_sales',
  theoretical_cash: 'theoretical_cash',
  actual_cash: 'actual_cash',
  cash_details: 'cash_details',
  bills: 'bills',
  coins: 'coins',
  cash_detail_total: 'cash_detail_total',
  auto_reflect_note: 'auto_reflect_note',
  cash_verification_complete: 'cash_verification_complete',
  no_variance: 'no_variance',
  variance_reason: 'variance_reason',
  variance_placeholder: 'variance_placeholder',
  submitting: 'submitting',
  execute_cash_settlement: 'execute_cash_settlement',
  cash_settlement_confirmation: 'cash_settlement_confirmation',
  variance_explanation: 'variance_explanation',
  verification_person: 'verification_person',
  cash_settlement_complete: 'cash_settlement_complete',
  cash_settlement_history: 'cash_settlement_history',
  settlement_date: 'settlement_date',
  beginning_cash_amount: 'beginning_cash_amount',
  system_cash_sales_amount: 'system_cash_sales_amount',
  expected_cash_amount: 'expected_cash_amount',
  verified_cash_amount: 'verified_cash_amount',
  non_cash_sales: 'non_cash_sales',
  variance_amount: 'variance_amount',
  variance_explanation_note: 'variance_explanation_note',
  verification_person_name: 'verification_person_name',
  creation_time: 'creation_time',
  bill_unit: 'bill_unit',
  coin_unit: 'coin_unit',
  pagination_display: 'pagination_display',
  daily_register_close_title: 'daily_register_close_title',
  daily_register_close_history_action: 'daily_register_close_history_action',
  daily_register_close_cashless_sales: 'daily_register_close_cashless_sales',
  daily_register_close_cashless_sales_total:
    'daily_register_close_cashless_sales_total',
  daily_register_close_no_cashless_sales_today:
    'daily_register_close_no_cashless_sales_today',
  daily_register_close_cash_sales: 'daily_register_close_cash_sales',
  daily_register_close_cash_sales_total:
    'daily_register_close_cash_sales_total',
  daily_register_close_no_cash_sales_today:
    'daily_register_close_no_cash_sales_today',
  daily_register_close_recycle_consignment_cash_payout:
    'daily_register_close_recycle_consignment_cash_payout',
  daily_register_close_recycle_consignment_cash_payout_total:
    'daily_register_close_recycle_consignment_cash_payout_total',
  daily_register_close_no_recycle_consignment_cash_payout_today:
    'daily_register_close_no_recycle_consignment_cash_payout_today',
  daily_register_close_cash_count: 'daily_register_close_cash_count',
  daily_register_close_opening_cash: 'daily_register_close_opening_cash',
  daily_register_close_till_cash_movement:
    'daily_register_close_till_cash_movement',
  daily_register_close_cash_in_from_safe:
    'daily_register_close_cash_in_from_safe',
  daily_register_close_cash_out_to_safe:
    'daily_register_close_cash_out_to_safe',
  daily_register_close_cash_movement_net:
    'daily_register_close_cash_movement_net',
  daily_register_close_cash_movement_direction_error:
    'daily_register_close_cash_movement_direction_error',
  daily_register_close_sales_cash_in: 'daily_register_close_sales_cash_in',
  daily_register_close_recycle_consignment_cash_payout_deduction:
    'daily_register_close_recycle_consignment_cash_payout_deduction',
  daily_register_close_cash_change_deduction:
    'daily_register_close_cash_change_deduction',
  daily_register_close_system_cash_net: 'daily_register_close_system_cash_net',
  daily_register_close_expected_cash: 'daily_register_close_expected_cash',
  daily_register_close_counted_cash: 'daily_register_close_counted_cash',
  daily_register_close_denomination_breakdown:
    'daily_register_close_denomination_breakdown',
  daily_register_close_denomination_total:
    'daily_register_close_denomination_total',
  daily_register_close_breakdown_auto_reflect_note:
    'daily_register_close_breakdown_auto_reflect_note',
  daily_register_close_cash_count_matched:
    'daily_register_close_cash_count_matched',
  daily_register_close_no_over_short: 'daily_register_close_no_over_short',
  daily_register_close_over_short_reason:
    'daily_register_close_over_short_reason',
  daily_register_close_over_short_placeholder:
    'daily_register_close_over_short_placeholder',
  daily_register_close_complete_action: 'daily_register_close_complete_action',
  daily_register_close_confirmation_title:
    'daily_register_close_confirmation_title',
  daily_register_close_over_short_note: 'daily_register_close_over_short_note',
  daily_register_close_counted_by: 'daily_register_close_counted_by',
  daily_register_close_complete_message:
    'daily_register_close_complete_message',
  daily_register_close_history_title: 'daily_register_close_history_title',
  daily_register_close_date: 'daily_register_close_date',
  daily_register_close_opening_cash_amount:
    'daily_register_close_opening_cash_amount',
  daily_register_close_system_cash_net_amount:
    'daily_register_close_system_cash_net_amount',
  daily_register_close_expected_cash_amount:
    'daily_register_close_expected_cash_amount',
  daily_register_close_counted_cash_amount:
    'daily_register_close_counted_cash_amount',
  daily_register_close_cashless_sales_amount:
    'daily_register_close_cashless_sales_amount',
  daily_register_close_over_short_amount:
    'daily_register_close_over_short_amount',
  daily_register_close_over_short_note_table:
    'daily_register_close_over_short_note_table',
  daily_register_close_counted_by_name: 'daily_register_close_counted_by_name',
  daily_register_close_created_time: 'daily_register_close_created_time',
  daily_register_close_cash_payment_snapshot:
    'daily_register_close_cash_payment_snapshot',
  daily_register_close_cash_payment_snapshot_total:
    'daily_register_close_cash_payment_snapshot_total',
  daily_register_close_cashless_payment_snapshot:
    'daily_register_close_cashless_payment_snapshot',
  daily_register_close_cashless_payment_snapshot_total:
    'daily_register_close_cashless_payment_snapshot_total',
  daily_register_close_recycle_order_daily_stats_title:
    'daily_register_close_recycle_order_daily_stats_title',
  daily_register_close_recycle_order_daily_count_one:
    'daily_register_close_recycle_order_daily_count_one',
  daily_register_close_recycle_order_daily_count_other:
    'daily_register_close_recycle_order_daily_count_other',
  daily_register_close_no_recycle_order_daily_data:
    'daily_register_close_no_recycle_order_daily_data',
  daily_register_close_no_recycle_order_daily_stats_today:
    'daily_register_close_no_recycle_order_daily_stats_today',
  LgfgKzLakm: 'LgfgKzLakm',
  aZlHFzBReU: 'aZlHFzBReU',
  rutZCCoEKZ: 'rutZCCoEKZ',
  cJJAYaviIh: 'cJJAYaviIh',
  recycling_list: 'recycling_list',
  consignment_list: 'consignment_list',
  settlement_statement: 'settlement_statement',
  please_select_category_first: 'please_select_category_first',
  edit_product: 'edit_product',
  payment_info_2: 'payment_info_2',
  send_transfer_notice: 'send_transfer_notice',
  page_refactored: 'page_refactored',
  page_refactored_description: 'page_refactored_description',
  please_use_new_version: 'please_use_new_version',
  click_to_access_new_version: 'click_to_access_new_version',
  page_will_close_soon_warning: 'page_will_close_soon_warning',
  xoYbOlYPVF: 'xoYbOlYPVF',
  product_internal_images: 'product_internal_images',
  print_sg_order_invoice: 'print_sg_order_invoice',
  payment_receipt_images: 'payment_receipt_images',
  payment_receipt_images_title_count: 'payment_receipt_images_title_count',
  payment_receipt_images_empty: 'payment_receipt_images_empty',
  payment_receipt_image_upload: 'payment_receipt_image_upload',
  payment_receipt_image_drag_hint: 'payment_receipt_image_drag_hint',
  payment_receipt_image_invalid_type: 'payment_receipt_image_invalid_type',
  batch_payment_voucher_entry: 'batch_payment_voucher_entry',
  payment_account: 'payment_account',
  please_select_payment_account: 'please_select_payment_account',
  payment_voucher_order_missing: 'payment_voucher_order_missing',
  payment_voucher_clipboard_paste_success:
    'payment_voucher_clipboard_paste_success',
  payment_voucher_clipboard_merge_notice:
    'payment_voucher_clipboard_merge_notice',
  payment_voucher_merge_success: 'payment_voucher_merge_success',
  payment_voucher_merge_failed: 'payment_voucher_merge_failed',
  payment_voucher_upload_tip: 'payment_voucher_upload_tip',
  selected_orders: 'selected_orders',
  order_currency_settlement_diff_warning:
    'order_currency_settlement_diff_warning',
  order_store_diff_error: 'order_store_diff_error',
  order_customer_diff_error: 'order_customer_diff_error',
  order_store_diff_submit_error: 'order_store_diff_submit_error',
  order_customer_diff_submit_error: 'order_customer_diff_submit_error',
  please_select_orders: 'please_select_orders',
  submission_success: 'submission_success',
  bkc_color_required: 'bkc_color_required',
  bkc_material_required: 'bkc_material_required',
  bkc_hardware_required: 'bkc_hardware_required',
  bkc_stamp_required: 'bkc_stamp_required',
  bkc_accessory_required: 'bkc_accessory_required',
  bkc_ai_identify_required: 'bkc_ai_identify_required',
  bkc_ai_task_required: 'bkc_ai_task_required',
  ai_identify_fill_bag_info_required: 'ai_identify_fill_bag_info_required',
  ai_identify_file_size_limit: 'ai_identify_file_size_limit',
  ai_identify_file_format_error: 'ai_identify_file_format_error',
  ai_identify_service_unavailable: 'ai_identify_service_unavailable',
  bkc_ai_identify_skip_confirm: 'bkc_ai_identify_skip_confirm',
  manual_review: 'manual_review',
  ai_authentication: 'ai_authentication',
  lent_out_preset_maintenance: 'lent_out_preset_maintenance',
  lent_out_preset_photography: 'lent_out_preset_photography',
  lent_out_preset_display: 'lent_out_preset_display',
  gift_with_purchase: 'gift_with_purchase',
  has_blank_margin: 'has_blank_margin',
  show_asset_qr_code: 'show_asset_qr_code',
  show_full_stamp: 'show_full_stamp',
  care_cost: 'care_cost',
  submit_and_copy: 'submit_and_copy',
  init_xm_assets: 'init_xm_assets',
  stock_taking_show_more: 'stock_taking_show_more',
  stock_taking_collapse: 'stock_taking_collapse',
  stock_taking_shown_count: 'stock_taking_shown_count',
  member_block_status: 'member_block_status',
  member_blocked: 'member_blocked',
  member_not_blocked: 'member_not_blocked',
  member_block: 'member_block',
  member_unblock: 'member_unblock',
  member_block_confirm: 'member_block_confirm',
  member_unblock_confirm: 'member_unblock_confirm',
  member_delete_account: 'member_delete_account',
  member_delete_account_confirm_title: 'member_delete_account_confirm_title',
  member_delete_account_confirm_content:
    'member_delete_account_confirm_content',
  member_deleted: 'member_deleted',
  member_change_email: 'member_change_email',
  member_change_email_confirm_title: 'member_change_email_confirm_title',
  member_change_email_confirm_content: 'member_change_email_confirm_content',
  member_change_email_new_email: 'member_change_email_new_email',
  member_change_email_current: 'member_change_email_current',
  member_change_email_same: 'member_change_email_same',
  member_change_email_exists: 'member_change_email_exists',
  refresh_member_level: 'refresh_member_level',
  refresh_member_level_confirm_title: 'refresh_member_level_confirm_title',
  refresh_member_level_confirm_content: 'refresh_member_level_confirm_content',
  refresh_member_level_changed: 'refresh_member_level_changed',
  refresh_member_level_unchanged: 'refresh_member_level_unchanged',
  non_cash_payment: 'non_cash_payment',
  non_cash_payment_total: 'non_cash_payment_total',
  test_environment_warning: 'test_environment_warning',
  operation: 'operation',
  commission_snapshot_upload_excel: 'commission_snapshot_upload_excel',
  commission_snapshot_snapshot_name: 'commission_snapshot_snapshot_name',
  commission_snapshot_source_file: 'commission_snapshot_source_file',
  commission_snapshot_importer: 'commission_snapshot_importer',
  commission_snapshot_confirm_delete_title:
    'commission_snapshot_confirm_delete_title',
  commission_snapshot_confirm_delete_desc:
    'commission_snapshot_confirm_delete_desc',
  commission_snapshot_delete_success: 'commission_snapshot_delete_success',
  commission_snapshot_upload_modal_title:
    'commission_snapshot_upload_modal_title',
  commission_snapshot_upload_and_parse: 'commission_snapshot_upload_and_parse',
  commission_snapshot_please_enter_name:
    'commission_snapshot_please_enter_name',
  commission_snapshot_name_placeholder: 'commission_snapshot_name_placeholder',
  commission_snapshot_excel_file: 'commission_snapshot_excel_file',
  commission_snapshot_drag_hint: 'commission_snapshot_drag_hint',
  commission_snapshot_format_hint: 'commission_snapshot_format_hint',
  commission_snapshot_select_file_first:
    'commission_snapshot_select_file_first',
  commission_snapshot_create_success: 'commission_snapshot_create_success',
  commission_snapshot_order_id: 'commission_snapshot_order_id',
  commission_snapshot_employee_name: 'commission_snapshot_employee_name',
  commission_snapshot_order_create_time:
    'commission_snapshot_order_create_time',
  commission_snapshot_payment_day: 'commission_snapshot_payment_day',
  commission_snapshot_receive_time: 'commission_snapshot_receive_time',
  commission_snapshot_product_id: 'commission_snapshot_product_id',
  commission_snapshot_product_quantity: 'commission_snapshot_product_quantity',
  commission_snapshot_is_tax_free: 'commission_snapshot_is_tax_free',
  commission_snapshot_order_total_tax: 'commission_snapshot_order_total_tax',
  commission_snapshot_product_cost_price:
    'commission_snapshot_product_cost_price',
  commission_snapshot_item_pay_amount: 'commission_snapshot_item_pay_amount',
  commission_snapshot_item_commission: 'commission_snapshot_item_commission',
  commission_snapshot_staff_in_charge: 'commission_snapshot_staff_in_charge',
  commission_snapshot_reception_staff_name:
    'commission_snapshot_reception_staff_name',
  commission_snapshot_self_owned: 'commission_snapshot_self_owned',
  commission_snapshot_total_count: 'commission_snapshot_total_count',
  commission_snapshot_input_order_id: 'commission_snapshot_input_order_id',
  commission_snapshot_input_product_id: 'commission_snapshot_input_product_id',
  commission_snapshot_max_100_chars: 'commission_snapshot_max_100_chars',
  commission_snapshot_max_500_chars: 'commission_snapshot_max_500_chars',
  commission_snapshot_optional: 'commission_snapshot_optional',
  daily_register_close_refund_payments: 'daily_register_close_refund_payments',
  daily_register_close_refund_payments_total:
    'daily_register_close_refund_payments_total',
  daily_register_close_no_refund_payments_today:
    'daily_register_close_no_refund_payments_today',
  daily_register_close_cash_refund_deduction:
    'daily_register_close_cash_refund_deduction',
  signed_contract_generate_pdf: 'signed_contract_generate_pdf',
  signed_contract_signature_required: 'signed_contract_signature_required',
  signed_contract_generate_pdf_failed: 'signed_contract_generate_pdf_failed',
  signed_contract_clear_signature: 'signed_contract_clear_signature',
  signed_contract_preview_and_send: 'signed_contract_preview_and_send',
  signed_contract_merge_hint_created: 'signed_contract_merge_hint_created',
  signed_contract_merge_hint_selected: 'signed_contract_merge_hint_selected',
  signed_contract_customer_signature: 'signed_contract_customer_signature',
  signed_contract_signature_hint: 'signed_contract_signature_hint',
  signed_contract_section_title: 'signed_contract_section_title',
  signed_contract_email_sent_time: 'signed_contract_email_sent_time',
  signed_contract_attachment: 'signed_contract_attachment',
  signed_contract_confirm_send_title: 'signed_contract_confirm_send_title',
  signed_contract_confirm_send_content: 'signed_contract_confirm_send_content',
  signed_contract_confirm_send: 'signed_contract_confirm_send',
  signed_contract_email_sent_success: 'signed_contract_email_sent_success',
  signed_contract_send_failed: 'signed_contract_send_failed',
  signed_contract_download_failed: 'signed_contract_download_failed',
  signed_contract_missing_order_ids: 'signed_contract_missing_order_ids',
  signed_contract_review_before_send: 'signed_contract_review_before_send',
  signed_contract_download_pdf: 'signed_contract_download_pdf',
  signed_contract_close: 'signed_contract_close',
  bkc_ai_identify_not_completed: 'bkc_ai_identify_not_completed',
  supplier_type: 'supplier_type',
  supplier_type_individual: 'supplier_type_individual',
  supplier_type_company: 'supplier_type_company',
  product_tax_regime: 'product_tax_regime',
  product_tax_regime_standard_tva: 'product_tax_regime_standard_tva',
  product_tax_regime_margin: 'product_tax_regime_margin',
  product_tax_regime_pending: 'product_tax_regime_pending',
  authentication_uncertain_result: 'authentication_uncertain_result',
  remark_template_default_filled_hint: 'remark_template_default_filled_hint',
  related_images: 'related_images',
  customer_info_record_template: 'customer_info_record_template',
  switch_account: 'switch_account',
  login_new_account: 'login_new_account',
  switch_account_hint: 'switch_account_hint',
  cached_accounts_empty: 'cached_accounts_empty',
  current_account: 'current_account',
  switch: 'switch',
  remove: 'remove',
  remove_cached_account_title: 'remove_cached_account_title',
  remove_cached_account_current_content:
    'remove_cached_account_current_content',
  remove_cached_account_other_content: 'remove_cached_account_other_content',
  token_expired_relogin: 'token_expired_relogin',
  switch_account_failed: 'switch_account_failed',
  account_not_found: 'account_not_found',
  quick_switch_logged_in_accounts: 'quick_switch_logged_in_accounts',
  enter_account: 'enter_account',
  token_valid: 'token_valid',
  or_login_new_account_below: 'or_login_new_account_below',
  token_expiry_unknown: 'token_expiry_unknown',
  token_expired_at: 'token_expired_at',
  token_valid_until: 'token_valid_until',
  token_expired: 'token_expired',
  close: 'close',
  manual_review_confirmer: 'manual_review_confirmer',
  operation_remark_upload_tip: 'operation_remark_upload_tip',
  authentication_point_review_placeholder:
    'authentication_point_review_placeholder',
  authentication_point_review_submit: 'authentication_point_review_submit',
  authentication_point_review_submit_success:
    'authentication_point_review_submit_success',
  authentication_point_review_nothing_to_submit:
    'authentication_point_review_nothing_to_submit',
  authentication_point_review_batch_result:
    'authentication_point_review_batch_result',
  authentication_point_reviewed_by: 'authentication_point_reviewed_by',
  authentication_point_reviewed_at: 'authentication_point_reviewed_at',
  inbox: 'inbox',
  phone: 'phone',
  other: 'other',
  country_code: 'country_code',
  country: 'country',
  jpn: 'jpn',
  city: 'city',
  write_your_message: 'write_your_message',
  press_enter_to_send: 'press_enter_to_send',
  sessions: 'sessions',
  profile: 'profile',
  set_profile_with_information: 'set_profile_with_information',
  greetings: 'greetings',
  set_a_greeting_message_for_customers_while_starting_a_conversation:
    'set_a_greeting_message_for_customers_while_starting_a_conversation',
  offline_response: 'offline_response',
  set_auto_reply_pre_settled_messages_while_outside_business_hours:
    'set_auto_reply_pre_settled_messages_while_outside_business_hours',
  business_hours: 'business_hours',
  set_business_hours: 'set_business_hours',
  image: 'image',
  timezone: 'timezone',
  save: 'save',
  set_business_hour: 'set_business_hour',
  at_least_one_business_hour_needs_to_be_set_up:
    'at_least_one_business_hour_needs_to_be_set_up',
  set_holiday: 'set_holiday',
  any_changes_for_today_will_not_be_possible:
    'any_changes_for_today_will_not_be_possible',
  documents: 'documents',
  share_files_description: 'share_files_description',
  photos: 'photos',
  share_photos_description: 'share_photos_description',
  upload_new_image: 'upload_new_image',
  delete_image: 'delete_image',
  enter_name: 'enter_name',
  enter_contact_number: 'enter_contact_number',
  enter_button_content: 'enter_button_content',
  auto_reply_message: 'auto_reply_message',
  add_response: 'add_response',
  add_new_offline_button_and_reply_message:
    'add_new_offline_button_and_reply_message',
  'Sent an attachment': 'Sent an attachment',
  'Sent {{count}} attachments': 'Sent {{count}} attachments',
  at_least_one_business_hour: 'at_least_one_business_hour',
  add_day_time: 'add_day_time',
  changes_not_possible_today: 'changes_not_possible_today',
  add_holiday: 'add_holiday',
  start_date: 'start_date',
  end_date: 'end_date',
  day_of_week: 'day_of_week',
  customer_details: 'customer_details',
  no_selected_session: 'no_selected_session',
  new_tag: 'new_tag',
  batch_convert_to_multi_stock: 'batch_convert_to_multi_stock',
  batch_convert_to_multi_stock_confirm: 'batch_convert_to_multi_stock_confirm',
  batch_convert_to_multi_stock_success: 'batch_convert_to_multi_stock_success',
  batch_convert_to_multi_stock_result: 'batch_convert_to_multi_stock_result',
  batch_convert_to_multi_stock_partial: 'batch_convert_to_multi_stock_partial',
  stock_taking_checked_quantity: 'stock_taking_checked_quantity',
  stock_taking_checked_quantity_required:
    'stock_taking_checked_quantity_required',
  stock_taking_system_stock: 'stock_taking_system_stock',
  stock_taking_multi_stock_confirm_title:
    'stock_taking_multi_stock_confirm_title',
  stock_taking_multi_stock_confirm_tip: 'stock_taking_multi_stock_confirm_tip',
  product_image_count: 'product_image_count',
  show_all: 'show_all',
  product_box_select_placeholder: 'product_box_select_placeholder',
  product_box_category_default_hint: 'product_box_category_default_hint',
  batch_sync_es: 'batch_sync_es',
  batch_sync_es_success: 'batch_sync_es_success',
  fill_reception_form: 'fill_reception_form',
  view_reception_form: 'view_reception_form',
  reception_form: 'reception_form',
  new_reception_form: 'new_reception_form',
  reception_date: 'reception_date',
  reception_bound: 'reception_bound',
  reception_unbound: 'reception_unbound',
  reception_bind: 'reception_bind',
  reception_unbind: 'reception_unbind',
  reception_unbind_confirm: 'reception_unbind_confirm',
  reception_bind_success: 'reception_bind_success',
  reception_unbind_success: 'reception_unbind_success',
  reception_submission_invalid: 'reception_submission_invalid',
  reception_direct_create: 'reception_direct_create',
  reception_select_member_hint: 'reception_select_member_hint',
  consignment_agreement: 'consignment_agreement',
  sign_consignment_agreement: 'sign_consignment_agreement',
  view_consignment_agreement: 'view_consignment_agreement',
  consignment_agreement_not_ready: 'consignment_agreement_not_ready',
  consignment_agreement_sign: 'consignment_agreement_sign',
  consignment_agreement_clear: 'consignment_agreement_clear',
  consignment_agreement_sns: 'consignment_agreement_sns',
  consignment_agreement_sns_multiple: 'consignment_agreement_sns_multiple',
  consignment_agreement_customer: 'consignment_agreement_customer',
  consignment_agreement_bring_in_no: 'consignment_agreement_bring_in_no',
  consignment_agreement_signed_at: 'consignment_agreement_signed_at',
  consignment_agreement_success: 'consignment_agreement_success',
  consignment_agreement_hint: 'consignment_agreement_hint',
  consignment_agreement_agree_required: 'consignment_agreement_agree_required',
  consignment_agreement_back: 'consignment_agreement_back',
};

export default LOCALS;
